import { useCallback, useEffect, useState } from 'react';
import api from '../services/api.js';
import { mapNormatividadCategories } from '../constants/normatividadCategories.js';

export function useNormatividadCategories({ admin = false } = {}) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      if (admin) {
        const { data } = await api.get('/v1/normatividad/categorias', {
          params: { per_page: 100 },
        });
        if (data.success) {
          setCategories(mapNormatividadCategories(data.data.items));
        }
      } else {
        const { data } = await api.get('/v1/public/normatividad/categorias');
        if (data.success) {
          setCategories(mapNormatividadCategories(data.data));
        }
      }
    } catch {
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, [admin]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { categories, loading, reload };
}
